import { useGlobalContext } from "context/GlobalContext";
import { useModuleAccessNavContext } from "context/ModuleAccessNavContext";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { decodeAccessLevelCode } from "utils/decodeAccessLevelCode";

export const SetPageAccessRoutes = () => {
  const { accessCodeMap } = useModuleAccessNavContext();
  const [shouldRedirect, setShouldRedirect] = useState(true);
  const { setPageAccess, isInitializing } = useGlobalContext();
  const location = useLocation();
  const { subModuleAccess } = useSelector((state) => state.roles.state);
  useEffect(() => {
    if (!isInitializing) {
      const currentPageAccessCode = accessCodeMap[location.pathname];
      if (!subModuleAccess[currentPageAccessCode]) {
        setShouldRedirect(false);
        return;
      }
      const accessLevel = decodeAccessLevelCode(
        subModuleAccess[currentPageAccessCode]
      );
      setShouldRedirect(true);
      setPageAccess(accessLevel);
    }
  }, [location.pathname, isInitializing]);
  if (shouldRedirect) {
    return <Outlet />;
  } else {
    return <Navigate to="/" />;
  }
};
